<template>
  <v-app-bar dark>
    <v-btn icon large color="white" class="v-app-bar__nav-icon" @click="goBack">
      <v-icon>keyboard_arrow_left</v-icon>
    </v-btn>
    <div class="text-center text-h6 full-width">
      <template v-if="reportingCustomerName">
        {{ reportingCustomerName }}'s
      </template>
      Reporting Hub
    </div>
    <v-btn icon large color="white" class="v-app-bar__nav-icon" @click="close">
      <v-icon>close</v-icon>
    </v-btn>
    <template v-slot:extension v-if="report">
      <v-container>
        <v-breadcrumbs class="pa-0 font-weight-bold" :items="breadcrumbList">
          <template v-slot:item="{ item }">
            <v-breadcrumbs-item
              exact
              :class="item.to ? 'primary--text' : 'secondary--text'"
              :to="item.to"
            >
              {{ item.text }}
            </v-breadcrumbs-item>
          </template>
          <template v-slot:divider>
            <v-icon color="secondary">keyboard_arrow_right</v-icon>
          </template>
        </v-breadcrumbs>
      </v-container>
    </template>
  </v-app-bar>
</template>

<script>
import { mapGetters } from "vuex";
import reports from "@/helpers/mixins/reports";
import { getReportingCompanyName } from "@/helpers/local";
export default {
  name: "ReportingDetails",
  components: {},
  data: () => ({
    loading: false,
    reportingCustomerName: null
  }),
  watch: {
    customer_settings(val, oldVal) {
      if (val != oldVal) {
        let self = this;
        setTimeout(function() {
          self.setReportingCustomerName();
        }, 200);
      }
    }
  },
  mixins: [reports],
  computed: {
    report() {
      return this.reports.find(
        x =>
          this.$route.params.parentId == x.typeUrl &&
          this.$route.params.reportId == x.url
      );
    },
    breadcrumbList() {
      let link = "/reporting";
      let list = [{ text: "Reporting", to: link }];

      if (this.report) {
        if (this.report.typeUrl) {
          link += `/${this.report.typeUrl}`;
          list.push({
            text: this.report_types
              .filter(x => x.url == this.report.typeUrl)
              .map(x => x.name)[0],
            to: link
          });
        }

        link += `/${list.url}`;
        list.push({ text: this.t2(this.report.name) });
      }
      return list;
    },
    ...mapGetters({
      customer_settings: "customer/customer_settings",
      return_url: "reporting/return_url",
      reports: "reporting/reports",
      report_types: "lookup/report_types"
    })
  },
  created() {
    this.setReportingCustomerName();
  },
  methods: {
    setReportingCustomerName() {
      this.reportingCustomerName =
        this.$auth.isSuperAdmin() || this.$auth.isCoreCoach()
          ? getReportingCompanyName()
          : null;
    },
    goBack() {
      this.$router.go(-1);
    },
    close() {
      if (this.return_url) {
        this.$router.push({ path: this.return_url });
      } else {
        this.$router.push({ path: "/" });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .v-toolbar__extension {
  background-color: white !important;
}
</style>
